import * as yup from 'yup';

export const formSchema = yup.object().shape({
  email: yup
    .string()
    .email('Você precisa inserir um e-mail válido.')
    .required('Este campo é obrigatório.'),
  group: yup.string().required('Selecione pelo menos um grupo.'),
});
